function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import TopSection from "./components/sections/top-section";
import BottomSection from "./components/sections/bottom-section";
var language = document.documentElement.lang;
var mobileWidth = 992;
var defaultDictionary = {
  Common: {
    home: "Home",
    more: "More"
  }
};
var FooterApp = function FooterApp(_ref) {
  var settings = _ref.settings;
  var elements = settings.elements,
    postElementTaggedItems = settings.postElementTaggedItems,
    taggedElements = settings.taggedElements;
  var _useState = useState(_objectSpread({}, defaultDictionary)),
    _useState2 = _slicedToArray(_useState, 2),
    dictionary = _useState2[0],
    setDictionary = _useState2[1];
  var _useState3 = useState(window.innerWidth <= mobileWidth),
    _useState4 = _slicedToArray(_useState3, 2),
    isMobile = _useState4[0],
    setIsMobile = _useState4[1];
  useEffect(function () {
    var dictionaryCopy = JSON.parse(JSON.stringify(defaultDictionary));
    DGS.Dictionary.getInstance().getTexts(dictionaryCopy, function () {
      setDictionary(dictionaryCopy);
    }, language);
    var handleWindowSizeChange = function handleWindowSizeChange() {
      return setIsMobile(window.innerWidth <= mobileWidth);
    };
    window.addEventListener("resize", handleWindowSizeChange);
    return function () {
      return window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TopSection, {
    data: isMobile ? elements.filter(function (el) {
      return !el.tags.includes("logoGroup");
    }) : elements,
    language: language,
    dictionary: dictionary,
    isMobile: isMobile
  }), /*#__PURE__*/React.createElement(BottomSection, {
    links: postElementTaggedItems.link,
    text: postElementTaggedItems.text,
    logo: taggedElements.logoGroup.items[0],
    isMobile: isMobile
  }));
};
export default FooterApp;